export const GET_TOURIST_SPOT_PHOTO_USER_REQUEST =
  "GET_TOURIST_SPOT_PHOTO_USER_REQUEST";
export const GET_TOURIST_SPOT_PHOTO_USER_SUCCESS =
  "GET_TOURIST_SPOT_PHOTO_USER_SUCCESS";
export const GET_TOURIST_SPOT_PHOTO_USER_FAILURE =
  "GET_TOURIST_SPOT_PHOTO_USER_FAILURE";
